import { render, staticRenderFns } from "./regionCostAscription.vue?vue&type=template&id=21cb5384&scoped=true"
import script from "./regionCostAscription.vue?vue&type=script&lang=js"
export * from "./regionCostAscription.vue?vue&type=script&lang=js"
import style0 from "./regionCostAscription.vue?vue&type=style&index=0&id=21cb5384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cb5384",
  null
  
)

export default component.exports